import * as React from "react";
import { Icon } from "../Icon/icon";

export interface IMenuButtonProps {
  menuStateCallback: any;
  menuText: string;
  menuIsOpen: boolean;
  menuId: string;
  ariaLabel?: string;
}

/**
 * Hamburger button
 */
export const MenuButton: React.SFC<IMenuButtonProps> = (props) => (
  <button
    onClick={props.menuStateCallback}
    className="siteheader__button"
    aria-expanded={props.menuIsOpen}
    aria-controls={props.menuId}
    aria-label={props.ariaLabel}
  >
    <Icon iconType="fontawesome/menu" className="button-open" />

    <span className="button-close">
      <Icon iconType="fontawesome/close-menu" />
    </span>
    <span className="display-block">{props.menuText}</span>
  </button>
);
